module.exports = __webpack_public_path__ + "img/symbol_16_normal.a62466db.png";